module.exports = __webpack_public_path__ + "media/assets/images/layout/p-network-logo-985585ba112b3e651be73f4a6f36d727.png";